import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

import content from '../content';
import useWindowPosition from '../hook/useWindowPosition';
import Link from '@material-ui/core/Link';

export default function Contact() {
	const animated = useWindowPosition('header', 0.6, 4);
	return (
		<div className=" min-h-screen  flex justify-center items-center  " id="mycontact">
			<div
				style={{
					minHeight: '50vh',
					background: '#091C29',
				}}
				className="w-full md:w-4/5 md:rounded-xl shadow-2xl flex md:flex-row flex-col-reverse justify-around items-center"
			>
				<LazyLoadImage
					effect="blur"
					src={content.contact.img}
					placeholderSrc={content.contact.imgPlaceholder}
					alt="profile"
					width="300px"
					style={{ marginLeft: '-23px', marginTop: '-40px' }}
					className="transtion duration-2000 ease-in-out mx-auto"
				/>

				<div className="font-dosis w-4/5 md:w-2/5 mt-5 transtion duration-2000">
					<h1
						className={`${
							animated ? '' : 'translate-y-10 opacity-0'
						} transform transition duration-3000 text-white text-5xl font-bold`}
					>
						{content.contact.title}
					</h1>
					<p
						className={`${
							animated ? '' : 'translate-y-10 opacity-0'
						} transform transition duration-3000 text-white text-2xl`}

						// style={{
						// 	'--color-1': 'darkmagenta',
						// 	'--color-2': 'darkcyan',
						// 	background: `
						// 	  linear-gradient(
						// 		170deg,
						// 		var(--color-1),
						// 		var(--color-2) 80%
						// 	  )
						// 	`,
						
							
						//   }}

                       style={{
						  background: `-webkit-linear-gradient(
							to right,
							lightcyan,
							#c471ed,
							#12c2e9
						  )`, /* Chrome 10-25, Safari 5.1-6 */
						  background: `linear-gradient(
							to right,
							lightcyan,
							#c471ed,
							#12c2e9
						  )`, /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
						  'background-clip': 'text',
						  '-webkit-background-clip': 'text',
						  'color': 'transparent'
						}
					}
					>
						{content.contact.desc}
					</p>
					<div
						className={`flex ${
							animated ? '' : 'translate-y-10 opacity-0'
						} transform transition duration-3000 `}
						style={{ marginTop: 'inherit', color: 'aqua' }}
					>
						{'Copyright © '}
						<Link color="inherit">TiashaBhowmik</Link> {new Date().getFullYear()}
						{'.'}
					</div>
				</div>
			</div>
		</div>
	);
}
